import actionTypes from './actionTypes';

export const initialState = {
  modalType: null,
  modalProps: {},
};

export default function Reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.MODAL_UNSET:
      return initialState;
    case actionTypes.MODAL_SET:
      return {
        ...state,
        modalType: action.modalType,
        modalProps: action.modalProps,
      };
    case actionTypes.MODAL_SET_PROPS:
      return {
        ...state,
        modalProps: action.modalProps,
      };
  }
  return state;
}
